export class ApiError extends Error {
  code?: number;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cause?: string | any;

  constructor(message: string, code?: number, cause?: string) {
    super(message);

    this.name = 'ApiError';
    this.code = code;
    this.cause = cause;
  }
}

export interface Paginator {
  page: number;
  per_page: number;
  offset: number;
  total_entries_size: number;
  current_entries_size: number;
  total_pages: number;
  order_by?: string;
  order_dir?: string;
  filter?: string;
}

export interface PaginatedResult<T> {
  results: T[];
  paginator?: Paginator;
}

export interface ApiResponse<T> {
  success: boolean;
  requestId: string;
  data: T;
  error?: string;
}

export interface ApiPaginatedResponse<T> {
  success: boolean;
  requestId: string;
  data: PaginatedResult<T>;
  error?: string;
}
